import axios from '@/libs/http'

/**
 * 音频转mp3格式
 */
export const audioToMp3 = (audio) => {
  let data = new URLSearchParams()
  data.append("audio", audio)

  return axios.request({
    url: '/u/file/audioToMp3',
    method: 'post',
    data
  })
}


/**
 * 微信音频素材ID转mp3格式
 */
export const wxAudioMediaIdToMp3 = (mediaId) => {
  let data = new URLSearchParams()
  data.append("mediaId", mediaId)

  return axios.request({
    url: '/u/file/wxAudioMediaIdToMp3',
    method: 'post',
    data
  })
}

